module.exports = __webpack_public_path__ + "media/images/oficinas/monte_caseros-4cdb8d7e13a310497e9020da80fffebd.jpg";